module.exports = __webpack_public_path__ + "img/ico_landing-questions.b55c95e7.svg";